import moment from "moment";
import { BaseEntity, getCachedSolarSystemEntity } from ".";
import { IGet_characters_character_id_mining_200_ok } from "../service/esiclient";
import { getCachedTypeEntity } from "./TypeEntityCache";

export class MiningEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Mining Entry";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_characters_character_id_mining_200_ok> = this.props;
    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      // - Id
      if (Object.prototype.hasOwnProperty.call(entity.properties, "id")) {
        delete entity.properties.id;
      }
      // - Name
      let name = "(Unknown)";
      if (props.type_id && props.quantity) {
        const typeEntity = await getCachedTypeEntity(props.type_id);
        if (typeEntity != null) {
          entity.properties["name"] = {
            type: Excel.CellValueType.string,
            basicValue: typeEntity.props.name,
          };
          name = typeEntity.props.name;
        }
        entity.text = name + " x " + props.quantity;
      } else {
        entity.properties["name"] = {
          type: Excel.CellValueType.string,
          basicValue: name,
        };
        entity.text = name;
      }
      if (props.date) {
        const date = moment(props.date);
        entity.properties["date"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: date.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
        entity.properties["date_unix"] = {
          type: Excel.CellValueType.double,
          basicValue: date.unix(),
        };
      }
      if (props.quantity) {
        entity.properties["quantity"] = {
          type: Excel.CellValueType.double,
          basicValue: props.quantity,
        };
      }
      if (props.type_id) {
        entity.properties["type_id"] = {
          type: Excel.CellValueType.double,
          basicValue: props.type_id,
        };
      }
      if (props.solar_system_id) {
        const system = await getCachedSolarSystemEntity(props.solar_system_id);
        if (system !== null) {
          entity.properties["solar_system"] = await system.toJson();
          entity.properties["solar_system_id"] = {
            type: Excel.CellValueType.double,
            basicValue: props.solar_system_id,
          };
        }
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
